$( document ).ready(function() {

    $("#static-contact-button").click(function(){
        validateForm();
    });

    $("#static-contact-button").submit(function(){
        return false;
    });

});

function validateForm(){

    hideErrors();

    var validated = true, salutation;

    var company = $('#company-input').val();
    var name = $('#name-input').val();
    var number = $('#number-input').val();
    var mail = $('#mail-input').val();
    var subject = $('#subject-input').val();
    var message = $('#message-input').val();

    if(name.length < 1) {
        $('#name-error').removeClass('hidden');
        validated = false;
    }
    else if (mail.length < 1) {
        $('#mail-error').removeClass('hidden');
        validated = false;
    }
    else if (message.length < 1) {
        $('#message-error').removeClass('hidden');
        validated = false;
    }

    if($('#mr-input').is(':checked')){
        salutation = "Mr.";
    }
    else if($('#ms-input').is(':checked')){
        salutation = "Ms.";
    }
    else if($('#mrs-input').is(':checked')) {
        salutation = "Mrs."
    }

    if(validated){
        $.ajax(
            {
                url : '/_contact',
                data : {
                    'salutation':salutation,
                    'company':company,
                    'name':name,
                    'phone':number,
                    'email':mail,
                    'subject':subject,
                    'message':message,
                    '_token': c_token
                },
                method: 'POST',
                success: function(data)
                {
                    showSuccess();
                }
            }
        );
    }
}

function hideErrors(){
    $('.error-message').addClass('hidden');
}

function showSuccess() {
    var accepted = $('.contact-accepted');
    accepted.removeClass('hidden');
    accepted.css({'opacity':'0'});
    $('.contact-content').slideUp(400);
    accepted.animate({'opacity':'1'},800);
}